var React = require('react');

function FlagBg (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 311.908h512v102.988a8.829 8.829 0 01-8.828 8.828H8.828A8.829 8.829 0 010 414.896V311.908z","fill":"#ff4b55","key":0}),React.createElement("path",{"d":"M8.828 88.276h494.345a8.829 8.829 0 018.828 8.828v102.988H0V97.104a8.829 8.829 0 018.828-8.828z","fill":"#f5f5f5","key":1}),React.createElement("path",{"fill":"#73af00","d":"M0 200.09h512V311.9H0z","key":2})]);
}

FlagBg.defaultProps = {"viewBox":"0 0 512.001 512.001"};

module.exports = FlagBg;

FlagBg.default = FlagBg;
